import Input from '@luminopia/react-toolbox/lib/input'
import * as React from 'react'
import {WrappedFieldProps} from 'redux-form'

/**
 * Properties passed to the component, excluding properties sent by the redux-form Field.
 */
export interface ITextFieldProps {
  disabled?: boolean
  label?: string
  placeholder?: string
  type?: string
  /** allowed field input, defaults to all input allowed */
  allowedInput?: RegExp
  onEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  theme?: ITheme
}

export interface ITheme {
  bar?: string // Used for the bar under the input.
  counter?: string // Used for the counter element.
  disabled?: string // Added to the root class when input is disabled.
  error?: string // Used for the text error.
  errored?: string // Added to the root class when input is errored.
  hidden?: string // Used when the input is hidden.
  hint?: string // Used for the hint text.
  icon?: string // Used for the icon in case the input has icon.
  input?: string // Used as root class for the component.
  inputElement?: string // Used for the HTML input element.
  label?: string // Used for the label when the input has a label.
  required?: string // Used in case the input is required.
  withIcon?: string // Added to the root class if the input has icon.
}

/**
 * All properties passed to the component, including those sent by the redux-form Field.
 */
export interface IProps extends ITextFieldProps, WrappedFieldProps<{}> {
}

export default class TextField extends React.Component<IProps, {}> {
  public static defaultProps: Partial<IProps> = {
    type: 'text',
  }
  constructor(props: IProps) {
    super(props)
    this.state = {
      blurred: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  public render(): React.ReactElement<{}> | null {
    if (!this.props.input) { return null }

    // Note: The field can manually be marked as disabled, but the field is also disabled while the form is submitting
    const disabled: boolean = !!(this.props.disabled || this.props.meta.submitting)

    const error = this.props.meta.touched ? this.props.meta.error : undefined

    return (
      <Input
        type={this.props.type}
        disabled={disabled}
        error={error}
        hint={this.props.placeholder}
        label={this.props.label}
        onChange={this.handleChange}
        onBlur={this.props.input.onBlur}
        onFocus={this.props.input.onFocus}
        onKeyPress={this.handleKeyPress}
        value={this.props.input.value}
        theme={this.props.theme}
      />
    )
  }

  protected handleChange(value: string): void {
    if  (!this.props.input) { return }
    const {allowedInput} = this.props
    const putValue = allowedInput
      ? (value.match(new RegExp(allowedInput, 'g')) || []).join('')
      : value
    this.props.input.onChange(putValue, undefined, undefined)
  }

  protected handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>): void {
    if (this.props.onEnter && event.key === 'Enter') {
      event.preventDefault()
      this.props.onEnter(event)
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/form/text-field.tsx